/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Button, Col, Row} from "react-bootstrap";
import SessionEndingExtendButtonComponent from "@Components/UI/Communicates/Session/Button";
import SessionEndingHeaderTextComponent from "@Components/UI/Communicates/Session/Header";
import SessionEndingInformationTextComponent from "@Components/UI/Communicates/Session/Information";
import SessionEndingLeftTimeComponent from "@Components/UI/Communicates/Session/LeftTime";


type SessionEndingCommunicateProps = {
    LEFT_SESSION_TIME: number;
};


export const SessionEndingCommunicateComponent: React.FC<SessionEndingCommunicateProps> = ({
    LEFT_SESSION_TIME = 0
}): JSX.Element | null => {


    if (!LEFT_SESSION_TIME) return null;


    return (
        <Col xs={12} className={"session-ending-information-component session-ending-information"}>
            <Row className={"session-ending-information-content"}>

                <SessionEndingLeftTimeComponent LEFT_SESSION_TIME={LEFT_SESSION_TIME} />

                <SessionEndingHeaderTextComponent />

                <SessionEndingInformationTextComponent />

                <SessionEndingExtendButtonComponent />

            </Row>
        </Col>
    );

};


export default SessionEndingCommunicateComponent;
